import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'da-hotels',
    templateUrl: './hotels.component.html',
    styleUrls: ['./hotels.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HotelsComponent implements OnInit {
    @Input() hotels;
    constructor() {}

    ngOnInit() {}
}
